import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Button from 'components/base/Button';
import { useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import authenticationService from 'services/authentication';

const ForgotPasswordForm = ({
  layout
}: {
  layout?: 'simple' | 'card' | 'split';
}) => {
  const [modalShow, setModalShow] = useState(false);
  const [errorModalShow, setErrorModalShow] = useState(false);
  const validateEmail = (value: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };
  const handleForgotPassword = () => {
    const email = document.getElementById('email') as HTMLInputElement;
    if (email.value === '' || !validateEmail(email.value)) {
      setErrorModalShow(true);
      return;
    }
    authenticationService
      .forgotPassword(email.value)
      .then(() => {
        setModalShow(true);
      })
      .catch(() => {
        // Handle the error here
        console.log('Login Error:', Error);
      });
  };
  return (
    <div className={classNames({ 'px-xxl-5': !(layout === 'split') })}>
      <div
        className={classNames('text-center', { 'mb-6': !(layout === 'split') })}
      >
        <h4 className="text-1000">Forgot your password?</h4>
        <p className="text-700 mb-5">
          Enter your email below and we will send <br className="d-sm-none" />
          you a reset link
        </p>
        <Form className="d-flex align-items-center mb-5">
          <Form.Control
            type="email"
            id="email"
            className="flex-1"
            placeholder="Email"
          />
          <Button
            variant="primary"
            className="ms-2"
            onClick={handleForgotPassword}
            endIcon={<FontAwesomeIcon icon={faChevronRight} className="ms-2" />}
          >
            Send
          </Button>
        </Form>
        <Link to={`/pages/faq/faq-tab`} className="fs-9 fw-bold">
          Still having problems?
        </Link>
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Great!</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>We are looking for your account!</h4>
            <p>If we find it, we will send you a reset link!</p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setModalShow(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={errorModalShow}
          onHide={() => setErrorModalShow(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Hmmm!</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Something not quite right there!</h4>
            <p>Have you entered a valid email address?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setErrorModalShow(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
